import React, { useEffect, useState } from 'react';
import { useCreateUserMutation } from './adminApiSlice';
import { FaEyeSlash, FaRegEye } from "react-icons/fa6";
import { HiOutlineUserAdd } from "react-icons/hi";
import { useNavigate } from 'react-router-dom';
import SelectBox from '../reduxworkbook/components/Aside2Components/DropzoneComponents/FilterConfigCompComponents/SelectBox';
const roles = [
  { label: "Admin", value: "Admin" },
  { label: "Creator", value: "Creator" },
  { label: "Explorer", value: "Explorer" },
  { label: "Viewer", value: "Viewer" }
];

export default function AddUser() {
  const [
    createUser,
    {
      data: addUserData,
      isLoading: isUserAddLoading,
      isError: isUserAddError,
      isSuccess: isUserAddSuccess,
      error: userAddError,
    },
  ] = useCreateUserMutation();

  const navigate = useNavigate();

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [checkUserFields, setCheckUserFields] = useState("");
  console.log(checkUserFields);

  const [addNewUserData, setAddNewUserData] = useState({
    username: "",
    email: "",
    department: "",
    role: "",
    lastLoginDate: "",
    status: true,
    password: "",
    confirmPassword: "",
    dob: "",
    zone: "",
    region: "",
    hierarchy: "",
    phone: "",
  });
  console.log(addNewUserData);

  useEffect(() => {
    if (addNewUserData.email === "") {
      console.log("email field is empty");
      setCheckUserFields("email field is empty")
    }
    if (addNewUserData.username === "") {
      console.log("username field is empty");
      setCheckUserFields("username field is empty")
    }
    if (addNewUserData.password !== addNewUserData.confirmPassword) {
      console.log("password and confirm password is not same");
      setCheckUserFields("password and confirm password is not same")
    }
    if (addNewUserData.username && addNewUserData.email && addNewUserData.password === addNewUserData.confirmPassword) {
      setCheckUserFields("")
    }
    if (addNewUserData.username === "" && addNewUserData.email === "" && addNewUserData.password !== addNewUserData.confirmPassword) {
      setCheckUserFields("")
    }
  }, [addNewUserData])

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAddNewUserData((prev) => ({ ...prev, [name]: value }));
  };
  const handleRoleChange = (e) => {
    setAddNewUserData((prev) => ({ ...prev, ["role"]: e.target.value }));
  };
  const handleAddNewUser = () => {
    const newUser = {
    username : addNewUserData.username,
    email: addNewUserData.email,
    department : addNewUserData.department,
    roles: addNewUserData.role,
    password : addNewUserData.password,
    confirmPassword : addNewUserData.confirmPassword,
    dob:addNewUserData.dob,
    zone : addNewUserData.zone,
    region : addNewUserData.region,
    hierarchy : addNewUserData.hierarchy,
    phone : addNewUserData.phone,
  }
    console.log(newUser);
    createUser(newUser);
  };
  if (isUserAddSuccess) {
    console.log(addUserData);
    navigate("/home/dash/admin")
  }

  return (
    <main className="overflow-hidden flex flex-col w-full h-[92vh]">
      <section className="flex items-center justify-between px-[0.8rem] border border-b-0 border-gray-300 h-[6%] font-medium w-full">
        {addNewUserData.username !== "" ? addNewUserData.username : "Add a new user"}
      </section>
      <section className="flex flex-wrap items-start justify-start p-[0.8rem] border border-b-0 border-gray-300 h-[65%] w-full">
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="username" className="font-medium">Username</label>
          <input
            type="text"
            name="username"
            placeholder="user123"
            value={addNewUserData.username}
            onChange={(e) => {
              const value = e.target.value.replace(/\s/g, ""); // Remove spaces
              handleInputChange({ target: { name: "username", value } });
            }}
            className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
          />
        </div>
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="email" className="font-medium">Email</label>
          <input type="email" name="email" placeholder="user123@gmail.com" onChange={handleInputChange} className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0" />
        </div>
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="password" className="font-medium">Password</label>
          <div className="relative w-full">
            <input
              type={passwordVisible ? "text" : "password"}
              name="password"
              placeholder="user123456"
              onChange={handleInputChange}
              className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
            />
            <button
              type="button"
              className="absolute right-[13.5%] top-[20.8%] focus:outline-0"
              onClick={() => setPasswordVisible(!passwordVisible)}
            >
              {passwordVisible ? <FaRegEye /> : <FaEyeSlash />}
            </button>
          </div>
        </div>
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="confirmPassword" className="font-medium">Confirm Password</label>
          <div className="relative w-full">
            <input
              type={confirmPasswordVisible ? "text" : "password"} name="confirmPassword" placeholder="user123456" onChange={handleInputChange} className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0" />
            <button
              type="button"
              className="absolute right-[13.5%] top-[20.8%] focus:outline-0"
              onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
            >
              {confirmPasswordVisible ? <FaRegEye /> : <FaEyeSlash />}
            </button>
          </div>
        </div>
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="dob" className="font-medium">Date of Birth</label>
          <input type="date" name="dob" onChange={handleInputChange} className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0" />
        </div>
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="phone" className="font-medium">Phone Number</label>
          <input
            type="tel"
            name="phone"
            placeholder="1234567890"
            value={addNewUserData.phone}
            onChange={(e) => {
              const { value } = e.target;
              if (/^\d*$/.test(value)) {
                handleInputChange(e);
              }
            }}
            className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0"
          />
        </div>
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="zone" className="font-medium">Zone</label>
          <input type="text" name="zone" placeholder="Zone" onChange={handleInputChange} className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0" />
        </div>
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="region" className="font-medium">Region</label>
          <input type="text" name="region" placeholder="Region" onChange={handleInputChange} className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0" />
        </div>
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="hierarchy" className="font-medium">Hierarchy</label>
          <input type="text" name="hierarchy" placeholder="Hierarchy" onChange={handleInputChange} className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0" />
        </div>
        <div className="flex flex-col w-[33%] items-start justify-start gap-2">
          <label htmlFor="department" className="font-medium">Department</label>
          <input type="text" name="department" placeholder="Department" onChange={handleInputChange} className="border rounded w-[88%] h-[4%] p-[0.2rem] focus:outline-0" />
        </div>
        <div className="flex w-[29%] items-center justify-start gap-2 relative top-[6%]">
          <label htmlFor="role" className="font-medium">Role</label>
          <SelectBox
            value={addNewUserData.role}
            onChange={handleRoleChange}
            optionsArray={roles}
          />
        </div>
      </section>
      <section className='flex items-center justify-end w-full h-[10%] px-[5rem] py-[0.8rem] gap-4'>
        {checkUserFields !== "" ? <p className='text-red-500 font-medium'>{checkUserFields}</p> : null}
        {isUserAddError ? <p className='text-red-500 font-medium'>{userAddError}</p> : null}
        <button
          className="border rounded py-2 px-3 text-gray-700 hover:bg-gray-200"
          onClick={() => navigate("/home/dash/admin")}
        >
          Cancel
        </button>
        <button
          className={`border rounded py-2 px-6  flex items-center justify-center gap-1 text-white ${checkUserFields !== "" ? " bg-gray-500" : " bg-blue-950"}`}
          onClick={handleAddNewUser}
          disabled={checkUserFields !== ""}
        >
          {isUserAddLoading ? " addding..." :
            <>
              Add
              <HiOutlineUserAdd />
            </>
          }
        </button>
      </section>
    </main>
  );
}
